import { AdminCollectionEditor } from '../../_Shared/_UI/AdminCollectionEditor';
import { AdminViewLayout } from '../../_Shared/_UI/AdminViewLayout';
import { ADMIN_DEFAULT_ORDER, ADMIN_FEATURED_FILTER, ADMIN_VISIBILITY_FILTER } from '../../_Shared/_Config/AdminCollectionFilters';
import { PROJECTS_ADMIN_API as API } from '../_MODULES/_API';
import '../../_Shared/_UI/_Styles/PortfolioAdmin.css';

const PROJECT_FILTERS = [
    ADMIN_VISIBILITY_FILTER,
    ADMIN_FEATURED_FILTER,
    {
        key: 'stack_filter',
        field: 'stack',
        label: 'Tecnologias',
        type: 'multi',
        tokenize: true,
        matchMode: 'any',
        placeholder: 'Seleccionar tecnologias…',
    },
];

export const ProjectsViewMain = () => (
    <AdminViewLayout
        pageKey="projects"
        title="Proyectos"
        description="Carga trabajos con portada, tecnologias, descripcion y enlaces. Podes ordenar, ocultar o destacar cada uno."
    >
        <AdminCollectionEditor
            title="Proyectos del portfolio"
            listEndpoint={API.LIST}
            saveEndpoint={API.SAVE}
            removeEndpoint={API.REMOVE}
            titleField="title"
            subtitleField="stack"
            imageField="image"
            searchFields={['title', 'slug', 'stack', 'description', 'url', 'repository']}
            filters={PROJECT_FILTERS}
            orderOptions={ADMIN_DEFAULT_ORDER('title')}
            fields={[
                { name: 'image', label: 'Portada', type: 'image', span: 2 },
                { name: 'title', label: 'Titulo' }, { name: 'slug', label: 'Slug (opcional)' },
                { name: 'stack', label: 'Tecnologias', span: 2 },
                { name: 'description', label: 'Descripcion', type: 'textarea', rows: 4, span: 2 },
                { name: 'url', label: 'URL del proyecto' }, { name: 'repository', label: 'Repositorio' },
                { name: 'sort_order', label: 'Orden', type: 'number', defaultValue: 0 },
                { name: 'featured', label: 'Destacado', type: 'checkbox' }, { name: 'active', label: 'Visible', type: 'checkbox', defaultValue: true },
            ]}
        />
    </AdminViewLayout>
);
